export default __webpack_public_path__ + "static/media/box1_bak.2ee1a4c1.png";